import React, { useState } from 'react';
import { Modal, Form, Input, Button, Upload } from 'antd';
import { UploadOutlined } from '@ant-design/icons';
import { toast } from 'react-hot-toast';
import { uploadShippingRulesBulkService } from '../../../core/services/shippingService';

interface Props {
    visible: boolean;
    onClose: () => void;
    onSuccess: () => void;
}

const ShippingBulkUploadModal: React.FC<Props> = ({ visible, onClose, onSuccess }) => {
    const [email, setEmail] = useState('');
    const [fileList, setFileList] = useState<any[]>([]);
    const [loading, setLoading] = useState(false);

    const handleSubmit = async () => {
        if (!fileList || fileList.length === 0) {
            toast.error('Please select a file to upload.');
            return;
        }
        if (!email.trim()) {
            toast.error('Please enter notification email address.');
            return;
        }

        const formData = new FormData();
        formData.append('file', fileList[0].originFileObj || fileList[0]);
        formData.append('email', email.trim());

        setLoading(true);
        try {
            const res = await uploadShippingRulesBulkService(formData);
            if (res?.data?.status || res?.status === 200) {
                toast.success('Shipping rules bulk file uploaded successfully.');
                setEmail('');
                setFileList([]);
                onSuccess();
                onClose();
            } else {
                toast.error(res?.data?.statusDescription || res?.data?.message || 'Failed to upload bulk shipping rules.');
            }
        } catch (err: any) {
            toast.error(err?.response?.data?.message || 'Error occurred while uploading file.');
        } finally {
            setLoading(false);
        }
    };

    return (
        <Modal
            title="Bulk Upload Shipping Rules"
            open={visible}
            onCancel={onClose}
            footer={[
                <Button key="cancel" onClick={onClose}>
                    Cancel
                </Button>,
                <Button key="submit" type="primary" loading={loading} onClick={handleSubmit} className="bg-blue-600">
                    Upload
                </Button>
            ]}
        >
            <Form layout="vertical" className="mt-4">
                <Form.Item label="Notification Email" required>
                    <Input
                        type="email"
                        placeholder="Enter email address to receive report"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                    />
                </Form.Item>

                <Form.Item label="Shipping Rules File (CSV / Excel)" required>
                    <Upload
                        beforeUpload={() => false}
                        maxCount={1}
                        fileList={fileList}
                        onChange={({ fileList }) => setFileList(fileList)}
                        accept=".csv,.xlsx,.xls"
                    >
                        <Button icon={<UploadOutlined />}>Select File</Button>
                    </Upload>
                </Form.Item>
            </Form>
        </Modal>
    );
};

export default ShippingBulkUploadModal;
